/**
 * 포인트 옵션별 결제 금액(BIZ-74) — 주문서 상품 카드·상세·결제 단계가 같은 계산을 쓴다.
 * 서버(apps/api domain/orderPoints.ts)와 같은 식: 할인 = min(총액, floor(총액 × 할인율)),
 * 적립 = floor(총액 × 적립율). 미리보기일 뿐이고 확정은 서버가 접수 때 다시 계산한다.
 */
export interface PointRates {
  earnRate: number
  discountRate: number
}

export interface PointPrice {
  /** 정가(적립 선택 시 결제 금액) */
  list: number
  /** 즉시할인 금액 */
  discount: number
  /** 즉시할인 선택 시 결제 금액 */
  discounted: number
  /** 적립 선택 시 쌓이는 포인트 */
  earn: number
}

export function pointPrice(total: number, rates: PointRates): PointPrice {
  const discount = Math.min(total, Math.floor(total * rates.discountRate))
  return { list: total, discount, discounted: total - discount, earn: Math.floor(total * rates.earnRate) }
}
